<template>
    <div class="ResetPassword">
        <div class="ResetPasswordBox">
            <img src="@/assets/images/Password/ResetPassword.png" />
            <el-form :model="ResetPasswordForm" label-width="0" :rules="ResetPasswordRules" ref="ResetPasswordRulesForm" class="demo-ruleForm">
                <el-form-item label="" prop="passWord">
                    <el-input v-model.trim="ResetPasswordForm.passWord" type="password" placeholder="请输入新密码" @keyup.enter.native="SetupComplete" show-password></el-input>
                </el-form-item>
                <el-form-item label="" prop="checkPass">
                    <el-input v-model.trim="ResetPasswordForm.checkPass" type="password" placeholder="请再次输入新密码" @keyup.enter.native="SetupComplete" show-password></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button style="padding: 20px 6px; width: 180px;" type="primary" size="medium" :icon="loginLoading ? 'el-icon-loading' : ''" :disabled="loginLoading" @click="SetupComplete">设置完成</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import * as API from '@/api/user';
export default {
    name: 'ResetPassword',
    data() {
        // 密码验证
        var validatePass = (rule, value, callback) => {
            if (!value || value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ResetPasswordForm.passWord) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            ResetPasswordForm: {},
            ResetPasswordRules: {
                passWord: [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }],
                checkPass: [{ required: true, validator: validatePass, trigger: 'blur' }]
            },
            loginLoading: false
        }
    },
    methods: {
        SetupComplete() {
            this.$refs.ResetPasswordRulesForm.validate((valid) => {
            if (valid) {
                    let params = this.ResetPasswordForm;
                    params.customerMobile = this.$route.query.customerMobile;
                    this.loginLoading = true;
                    API.changePassword(params).then(res => {
                        this.loginLoading = false;
                        if(res.code === 20000) {
                            this.$message({ type: 'success', message: '设置成功' });
                            this.$router.push({ path: "/SetOk" });
                        }
                    }).catch(err => {
                        this.loginLoading = false;
                        console.log(err);
                    });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped>
.ResetPassword {
    border-top: 1px solid #989797;
    margin-top: 12px;
}
.ResetPassword .ResetPasswordBox {
    margin: 0 auto;
    width: 1280px;
    margin-top: 100px;
    margin-bottom: 180px;
}
.ResetPassword .ResetPasswordBox img {
    vertical-align: middle;
}
.ResetPassword .ResetPasswordBox /deep/ .el-form {
    width: 668px;
    margin: 0 auto;
    margin-top: 60px
}
.ResetPassword .ResetPasswordBox /deep/ .el-form .el-input__inner {
    line-height: 56px;
    height: 56px;
}
.ResetPassword .ResetPasswordBox /deep/ .el-form .el-form-item {
    margin-bottom: 36px;
}
</style>